import { REGULATOR } from '../constants/regulators';
import { COUNTRIES_REGULATOR_MAPPER } from '../constants/regulators';
import { getFirstAvailableHub, getHubByRoutingHub } from './hubs';

export const getRegulatorByCountry = (country) => {
  return Object.keys(COUNTRIES_REGULATOR_MAPPER).find((regulator) =>
    COUNTRIES_REGULATOR_MAPPER[regulator].has(country),
  );
};

export const getRegulatorForUnauthUser = (routingHub, ipCountry) => {
  const regulator = getRegulatorByCountry(ipCountry);
  const { REGULATORS } = getHubByRoutingHub(routingHub) || getFirstAvailableHub();
  return regulator && REGULATORS.includes(regulator) ? regulator : REGULATORS[0];
};

export const isAsicRegulator = (userRegulator) => userRegulator === REGULATOR.ASIC;

export const isVfscRegulator = (userRegulator) => userRegulator === REGULATOR.VFSC;

export const isSeyRegulator = (userRegulator) => userRegulator === REGULATOR.SEY;

export const isCysecRegulator = (userRegulator) => userRegulator === REGULATOR.CYSEC;
